import React from 'react';

export interface TaskListOptionData {
    title?: string;
    itemIcon?: string;
    isSeparator?: boolean;
    [key: string]: unknown;
}

interface TaskListOptionProps {
    option: TaskListOptionData;
    children?: React.ReactNode;
    className?: string;
    isDisabled?: boolean;
    isFocused?: boolean;
    isSelected?: boolean;
    onFocus: (option: TaskListOptionData, event: React.MouseEvent<HTMLDivElement>) => void;
    onSelect: (option: TaskListOptionData, event: React.MouseEvent<HTMLDivElement>) => void;
}

export const TaskListOption = ({
    option,
    children,
    className,
    isFocused,
    onFocus,
    onSelect,
}: TaskListOptionProps) => {
    const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        onSelect(option, event);
    };

    const handleMouseEnter = (event: React.MouseEvent<HTMLDivElement>) => {
        onFocus(option, event);
    };

    const handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
        if (isFocused) return;
        onFocus(option, event);
    };

    const itemStyle: React.CSSProperties = option.isSeparator
        ? { borderTopWidth: '1px', borderTopStyle: 'solid', borderTopColor: '#DEE2E6' }
        : {};

    return (
        <div
            className={className}
            onMouseDown={handleMouseDown}
            onMouseEnter={handleMouseEnter}
            onMouseMove={handleMouseMove}
            title={option.title}
            style={itemStyle}>
            {option.itemIcon && <i className={`fa-regular fa-${option.itemIcon} me-1`}></i>} {children}
        </div>
    );
};

export default TaskListOption;
